import { api } from '@cwd/lib/main';

export interface TagSummary {
    TagId: string;
    Title: string;
    IsDeleted: boolean;
    UsageCount: number | null;
}

export function getTags(): Promise<TagSummary[]> {
    return api.get('/Tags');
}

export function createTag(title: string): Promise<TagSummary> {
    return api.post('/Tags', title);
}

export function updateTag(tag: TagSummary): Promise<void> {
    return api.post(`/Tags/${tag.TagId}`, tag);
}

export function deleteTag(tagId: string): Promise<void> {
    return api.delete(`/Tags/${tagId}`);
}

export function mergeTags(targetTagId: string, sourceTagIds: string[]): Promise<TagSummary> {
    return api.post(`/Tags/${targetTagId}/Merge`, sourceTagIds);
}
